import(/* webpackMode: "eager" */ "/home/ubuntu/deployment_scripts/frontend/src/app/(common)/privacy-policy/page.js");
